// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditCommunityContent {
  /* background-color: #FFF; */
  margin: 15px;
  border-radius: 20px;
  padding: 20px 15px 0px 15px;
}

.photoGrid {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 30px;
}

@media all and (max-width: 768px) {
  .photoGrid {
    gap: 17px;
  }
}

.Phototimelinecard {
  /* max-width: 250px; */
  /* position: relative; */
  border-radius: 15px !important;
  background-color: #efeeed !important;
  flex: 1 1 240px; /* responsive base width */
  max-width: 240px;
  min-width: 200px;
  box-sizing: border-box;
  transition: transform 0.2s ease;
}
.readMoreContainer{
  flex: 1 1 240px; /* responsive base width */
  max-width: 240px;
  min-width: 200px;
  box-sizing: border-box;
  transition: transform 0.2s ease;
}

.photoDescriptionArea {
  /* resize: none; */
  width: 100%;
  border-radius: 10px;
  outline: none;
  border: 1px solid;
  border-color: #b5b5b5;
  padding: 6px;
  margin: 5px 0 0px 0px;
  overflow: auto;
  font-size: 0.8em;
  height: 65px;
  scroll-behavior: smooth;
  scrollbar-width: none;
}

.LocationandCountDisplay {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.editPhotoDropDown {
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 2px 0 0 8px;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #efeeed;
  border: 1px solid #fff;
  cursor: pointer;
}

.PhotoEditDeleteOptions {
  display: none;
  position: absolute;
  top: 43px;
  background: #fff;
  padding: 15px;
  width: 193px;
  border-radius: 25px;

  list-style: none;
  z-index: 1;
  left: 75%;
}

.editPhotoDropDown:hover + .PhotoEditDeleteOptions {
  display: block;
}

.PhotoEditDeleteOptions > li > img {
  padding: 0 10px 2px 0;
}

.Phototimeline {
  position: relative;
  flex-basis: 31%;
}
@media all and (max-width: 991px) {
  .Phototimeline {
    flex-basis: 48%;
  }
}

.photoDescriptionWrapper {
  width: 100%;
  box-sizing: border-box;
  margin-top: 15px;
}

.AddPhoto {
  display: flex;
  justify-content: space-between;
  line-height: 20px;
}

.AddPhotoLink {
  display: flex;
  gap: 7px;
  color: #4795de;
  font-weight: bold;
  cursor: pointer;
}

.read-or-hide {
  color: #333333;
  cursor: pointer;
}

.initial-Description {
  color: #a9a9a9;
}

.textColor {
  color: #707070;
}

/* alert */
.photo-overcount-alert {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Remove Photo */
.remove-unwanted-photo {
  display: flex;
  padding: 0 18px;
  flex-flow: row;
  flex-shrink: revert-layer;
  flex-wrap: wrap;
  /* gap: 12px; */
  justify-content: space-between;
}

.remove-photo-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.remove-photo-header img {
  cursor: pointer;
}

.click-here {
  color: blue;
  cursor: pointer;
}

/* Community Info */
.communityInfo-input {
  margin-bottom: 1%;
}

.communityInfo-input p {
  position: relative;
  left: 2%;
  margin-bottom: 0.5%;
}

.communityInfo-input p span {
  color: #4795de;
}

.communityNameInput {
  width: 100%;
  border-radius: 25px;
  padding: 7px 15px;
  border: 1px solid #ced4da;
}

.mediumInput1 {
  flex-basis: 49%;
}
.mediumInput2 {
  flex-basis: 49%;
}
@media all and (max-width: 767px) {
  .mediumInput1 {
    flex-basis: 100%;
  }
  .mediumInput2 {
    flex-basis: 100%;
  }
}

.communityDescriptionInput {
  height: 100%;
  min-height: 82px;
  padding: 6px 0px 0px 18x;
  resize: none;
}

.country-dropdown {
  width: 100%;
  border-radius: 25px;
}

.addressandcity {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/*  Dropdown trigger (small circular icon button) */
.photo-dropdown-trigger {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s ease-in-out;
}

.photo-dropdown-trigger:hover {
  background-color: rgba(240, 240, 240, 1);
}

/*  Menu icon inside trigger */
.photo-dropdown-icon {
  width: 14px;
  height: 14px;
}

/*  Dropdown menu popup container */
.photo-dropdown-menu {
  position: absolute;
  top: 40px;
  right: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 140px;
  z-index: 10;
  overflow: hidden;
  animation: fadeIn 0.15s ease-in-out;
}

/*  Dropdown list (ul reset + spacing) */
.photo-dropdown-list {
  list-style: none;
  margin: 0;
  padding: 5px 0;
}

/*  Dropdown item (hover + flex layout for icon + text) */
.photo-dropdown-item {
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;
}

.photo-dropdown-item:hover {
  background-color: #f5f5f5;
}

/*  Icons in dropdown items */
.photo-dropdown-item-icon {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.photo-location {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  max-width: 200px; /* Adjust width as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-size: 14px;
  color: #333;
}

`, "",{"version":3,"sources":["webpack://./src/Assets/css/Moderator/EditCommunitys.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe,EAAE,0BAA0B;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,eAAe,EAAE,0BAA0B;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;;EAEnB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB,EAAE,2BAA2B;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb","sourcesContent":[".EditCommunityContent {\r\n  /* background-color: #FFF; */\r\n  margin: 15px;\r\n  border-radius: 20px;\r\n  padding: 20px 15px 0px 15px;\r\n}\r\n\r\n.photoGrid {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  justify-content: flex-start;\r\n  gap: 20px;\r\n  margin-top: 30px;\r\n}\r\n\r\n@media all and (max-width: 768px) {\r\n  .photoGrid {\r\n    gap: 17px;\r\n  }\r\n}\r\n\r\n.Phototimelinecard {\r\n  /* max-width: 250px; */\r\n  /* position: relative; */\r\n  border-radius: 15px !important;\r\n  background-color: #efeeed !important;\r\n  flex: 1 1 240px; /* responsive base width */\r\n  max-width: 240px;\r\n  min-width: 200px;\r\n  box-sizing: border-box;\r\n  transition: transform 0.2s ease;\r\n}\r\n.readMoreContainer{\r\n  flex: 1 1 240px; /* responsive base width */\r\n  max-width: 240px;\r\n  min-width: 200px;\r\n  box-sizing: border-box;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.photoDescriptionArea {\r\n  /* resize: none; */\r\n  width: 100%;\r\n  border-radius: 10px;\r\n  outline: none;\r\n  border: 1px solid;\r\n  border-color: #b5b5b5;\r\n  padding: 6px;\r\n  margin: 5px 0 0px 0px;\r\n  overflow: auto;\r\n  font-size: 0.8em;\r\n  height: 65px;\r\n  scroll-behavior: smooth;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.LocationandCountDisplay {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.editPhotoDropDown {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 5px;\r\n  padding: 2px 0 0 8px;\r\n  height: 30px;\r\n  width: 30px;\r\n  border-radius: 50%;\r\n  background-color: #efeeed;\r\n  border: 1px solid #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.PhotoEditDeleteOptions {\r\n  display: none;\r\n  position: absolute;\r\n  top: 43px;\r\n  background: #fff;\r\n  padding: 15px;\r\n  width: 193px;\r\n  border-radius: 25px;\r\n\r\n  list-style: none;\r\n  z-index: 1;\r\n  left: 75%;\r\n}\r\n\r\n.editPhotoDropDown:hover + .PhotoEditDeleteOptions {\r\n  display: block;\r\n}\r\n\r\n.PhotoEditDeleteOptions > li > img {\r\n  padding: 0 10px 2px 0;\r\n}\r\n\r\n.Phototimeline {\r\n  position: relative;\r\n  flex-basis: 31%;\r\n}\r\n@media all and (max-width: 991px) {\r\n  .Phototimeline {\r\n    flex-basis: 48%;\r\n  }\r\n}\r\n\r\n.photoDescriptionWrapper {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  margin-top: 15px;\r\n}\r\n\r\n.AddPhoto {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  line-height: 20px;\r\n}\r\n\r\n.AddPhotoLink {\r\n  display: flex;\r\n  gap: 7px;\r\n  color: #4795de;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.read-or-hide {\r\n  color: #333333;\r\n  cursor: pointer;\r\n}\r\n\r\n.initial-Description {\r\n  color: #a9a9a9;\r\n}\r\n\r\n.textColor {\r\n  color: #707070;\r\n}\r\n\r\n/* alert */\r\n.photo-overcount-alert {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Remove Photo */\r\n.remove-unwanted-photo {\r\n  display: flex;\r\n  padding: 0 18px;\r\n  flex-flow: row;\r\n  flex-shrink: revert-layer;\r\n  flex-wrap: wrap;\r\n  /* gap: 12px; */\r\n  justify-content: space-between;\r\n}\r\n\r\n.remove-photo-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n}\r\n\r\n.remove-photo-header img {\r\n  cursor: pointer;\r\n}\r\n\r\n.click-here {\r\n  color: blue;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Community Info */\r\n.communityInfo-input {\r\n  margin-bottom: 1%;\r\n}\r\n\r\n.communityInfo-input p {\r\n  position: relative;\r\n  left: 2%;\r\n  margin-bottom: 0.5%;\r\n}\r\n\r\n.communityInfo-input p span {\r\n  color: #4795de;\r\n}\r\n\r\n.communityNameInput {\r\n  width: 100%;\r\n  border-radius: 25px;\r\n  padding: 7px 15px;\r\n  border: 1px solid #ced4da;\r\n}\r\n\r\n.mediumInput1 {\r\n  flex-basis: 49%;\r\n}\r\n.mediumInput2 {\r\n  flex-basis: 49%;\r\n}\r\n@media all and (max-width: 767px) {\r\n  .mediumInput1 {\r\n    flex-basis: 100%;\r\n  }\r\n  .mediumInput2 {\r\n    flex-basis: 100%;\r\n  }\r\n}\r\n\r\n.communityDescriptionInput {\r\n  height: 100%;\r\n  min-height: 82px;\r\n  padding: 6px 0px 0px 18x;\r\n  resize: none;\r\n}\r\n\r\n.country-dropdown {\r\n  width: 100%;\r\n  border-radius: 25px;\r\n}\r\n\r\n.addressandcity {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n}\r\n\r\n/*  Dropdown trigger (small circular icon button) */\r\n.photo-dropdown-trigger {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  cursor: pointer;\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  border-radius: 50%;\r\n  width: 28px;\r\n  height: 28px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\r\n  transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n.photo-dropdown-trigger:hover {\r\n  background-color: rgba(240, 240, 240, 1);\r\n}\r\n\r\n/*  Menu icon inside trigger */\r\n.photo-dropdown-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n/*  Dropdown menu popup container */\r\n.photo-dropdown-menu {\r\n  position: absolute;\r\n  top: 40px;\r\n  right: 10px;\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  min-width: 140px;\r\n  z-index: 10;\r\n  overflow: hidden;\r\n  animation: fadeIn 0.15s ease-in-out;\r\n}\r\n\r\n/*  Dropdown list (ul reset + spacing) */\r\n.photo-dropdown-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 5px 0;\r\n}\r\n\r\n/*  Dropdown item (hover + flex layout for icon + text) */\r\n.photo-dropdown-item {\r\n  padding: 8px 15px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.photo-dropdown-item:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n/*  Icons in dropdown items */\r\n.photo-dropdown-item-icon {\r\n  margin-right: 8px;\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.photo-location {\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  max-width: 200px; /* Adjust width as needed */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  vertical-align: middle;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
